import React from 'react'

const ActivityTimeline = ({ activities }) => {
  return (
    <div className="timeline">
      {activities.map((item, index) => (
        <div className="timeline-item" key={item.id}>
          <div className={`timeline-dot ${item.type}`} />
          
          {index !== activities.length - 1 && (
            <div className="timeline-line" />
          )}

          <div className="timeline-content">
            <span className="timeline-time">{item.time}</span>
            <h6 className={item.description && 'mb-1'} style={{fontSize: 14}}>{item.title}</h6>
            {item.description && <p className='text-muted' style={{fontSize: 12}}>{item.description}</p>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityTimeline;
